/** Sent on hub API calls and copied into slowdown support tickets. */
export const HUB_CLIENT_REQUEST_ID_HEADER = "X-Hub-Client-Request-Id";

export function createHubClientRequestId(): string {
  const cryptoApi = globalThis.crypto;
  if (cryptoApi && typeof cryptoApi.randomUUID === "function") {
    return cryptoApi.randomUUID();
  }
  return `hub-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}
